<template>
    <div id="page-user-list">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserPlusIcon"
                icon-right
                :statistic="summary.count_in"
                statisticTitle="โยกเข้า/ครั้ง"
                color="success"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="UserMinusIcon"
                icon-right
                :statistic="summary.count_out"
                statisticTitle="โยกออก/ครั้ง"
                color="danger"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="FilePlusIcon"
                icon-right
                :statistic="summary.count_add"
                statisticTitle="เพิ่ม/ครั้ง"
                color="success"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="FileMinusIcon"
                icon-right
                :statistic="summary.count_minus"
                statisticTitle="ลด/ครั้ง"
                color="danger"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                icon-right
                :statistic="currency(summary.sum_credit_in)"
                statisticTitle="Transfer เข้า UFA "
                color="warning"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                icon-right
                :statistic="currency(summary.sum_credit_out)"
                statisticTitle="Transfer ออก UFA "
                color="warning"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                icon-right
                :statistic="currency(summary.sum_credit_add)"
                statisticTitle="เพิ่มเครดิต เข้า UFA"
                color="warning"
              />
            </div>
            <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
              <statistics-card-line
                hideChart
                class="mb-base"
                icon="DollarSignIcon"
                icon-right
                :statistic="currency(summary.sum_credit_minus)"
                statisticTitle="ลดเครดิต จาก UFA"
                color="warning"
              />
            </div>
          </div>
  
          <vx-card title="Filter">
            <div class="vx-row">
              <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <label class="vs-input--label">Start Date</label>
                <flat-pickr
                  class="w-full mt-4"
                  v-model="startDate"
                  :config="config"
                />
                <br />
              </div>
              <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <label class="vs-input--label">End Date</label>
                <flat-pickr
                  class="w-full mt-4"
                  v-model="endDate"
                  :config="config"
                />
                <br />
              </div>
              <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <label class="vs-input--label">Type</label>
                <!-- <v-select  v-model="month" :options="monthOptions" name="status"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
                <vs-select class="w-full mt-4" v-model="filterType">
                  <vs-select-item
                    :key="index"
                    :value="item.val"
                    :text="item.name"
                    v-for="(item, index) in filterSelectType"
                  />
                </vs-select>
                <br />
              </div>
              <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <label class="vs-input--label">Status</label>
                <!-- <v-select  v-model="month" :options="monthOptions" name="status"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
                <vs-select class="w-full mt-4" v-model="filterStatus">
                  <vs-select-item
                    :key="index"
                    :value="item.val"
                    :text="item.name"
                    v-for="(item, index) in filterSelectStatus"
                  />
                </vs-select>
                <br />
              </div>
              <div class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <label class="vs-input--label">Username</label>
                <vs-input
                  class="w-full mt-4"
                  type="text"
                  v-model="filterUsername"
                  placeholder="กรอก username"
                />
                <br />
              </div>
              <div class="vx-col w-full sm:w-1/6 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <label class="vs-input--label">จำนวนเงิน(ต่ำสุด-สูงสุด)</label>
  
                <vs-input
                  class="w-full mt-4"
                  type="number"
                  v-model="startAmont"
                />
                <br />
              </div>
              <label class="vs-input--label mt-12 mr-1">-</label>
              <div class="vx-col w-full sm:w-1/6 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <label class="vs-input--label"></label>
                <vs-input class="w-full mt-4" type="number" v-model="endAmont" />
                <br />
              </div>

            </div>
            <vs-button class="mr-2" color="success" @click="getDataTransaction(currentWebsite)"
              >Search</vs-button
            >
            <vs-button class="mr-2" color="warning" @click="getDataTransaction({ label: 'เว็บไซต์ทั้งหมด', value: 'all' })">ค้นหาทุกเว็บไซต์</vs-button>
            <vs-button color="primary" @click="clearSearchBox()">Clear</vs-button>
            
          </vx-card>
          <br />
  
          <vx-card title="Result">
            <div class="flex flex-wrap items-center justify-between mb-4">
              <div class="flex items-center">
                <span class="mr-2">รายการต่อหน้า:</span>
                <vs-select v-model="pagination.perPage" class="w-24">
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item.toString()"
                    v-for="(item, index) in [10, 20, 50, 100, 200]"
                  />
                </vs-select>
              </div>
            </div>
            <vs-table
              stripe
              :sst="true"
              @change-page="handlePageChange"
              :total="pagination.total"
              pagination
              sort
              :noDataText="noDataText"
              :max-items="pagination.perPage"
              :data="dataTransaction"
            >
              <template slot="thead">
                <vs-th sort-key="created_at">Datetime</vs-th>
                <vs-th sort-key="member_username">USERNANE</vs-th>
                <vs-th sort-key="amount">CREDIT</vs-th>
                <vs-th sort-key="direction">ช่องทาง</vs-th>
                <vs-th sort-key="source">ต้นทาง</vs-th>
                <vs-th sort-key="destination">ปลายทาง</vs-th>
                <vs-th sort-key="source_balance_before">ต้นทางก่อน</vs-th>
                <vs-th sort-key="source_balance_after">ต้นทางหลัง</vs-th>
                <vs-th sort-key="destination_balance_before">ปลายทางก่อน</vs-th>
                <vs-th sort-key="destination_balance_after">ปลายทางหลัง</vs-th>
                <vs-th sort-key="from_website">from</vs-th>
                <vs-th sort-key="status">STATUS</vs-th>
                <vs-th sort-key="error_message">Info</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.created_at">
                    {{ moment(tr.created_at).format("YYYY-MM-DD HH:mm:ss") }}
                  </vs-td>
                  <vs-td class="text-danger">
                    <router-link :to="`/member/${data[indextr].member_username}`">
                      {{ data[indextr].member_username }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="tr.amount">
                    {{ currency(tr.amount) }}
                  </vs-td>
                  <vs-td :data="tr.direction">
                    <span :class="textDirectionClass(tr.direction)">
                      {{ translateDirection(tr.direction) }}
                    </span>
                  </vs-td>
                  <vs-td :data="tr.source">
                    {{ tr.source }}
                  </vs-td>
                  <vs-td :data="tr.destination">
                    {{ tr.destination }}
                  </vs-td>
                  <vs-td :data="tr.source_balance_before">
                    {{ currency(tr.source_balance_before) }}
                  </vs-td>
                  <vs-td :data="tr.source_balance_after">
                    {{ currency(tr.source_balance_after) }}
                  </vs-td>
                  <vs-td :data="tr.destination_balance_before">
                    {{ currency(tr.destination_balance_before) }}
                  </vs-td>
                  <vs-td :data="tr.destination_balance_after">
                    {{ currency(tr.destination_balance_after) }}
                  </vs-td>
                  <vs-td :data="tr.from_website">
                    {{ tr.from_website }}
                  </vs-td>
                  <vs-td
                    :class="
                      data[indextr].status == 'success'
                        ? 'text-success'
                        : data[indextr].status == 'failed'
                        ? 'text-danger'
                        : ''
                    "
                  >
                    {{ check_status(data[indextr].status) }}
                  </vs-td>
                  <vs-td :data="tr.error_message">
                    {{ tr.error_message }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </div>
  </template>
  
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import axios from '../../axios'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    StatisticsCardLine,
    vSelect,
    flatPickr
  },
  data () {
    return {
      dataTransaction: [],
      summary: {},
      selected: '',
      noDataText: 'โปรดรอสักครู่ ระบบกำลังดึงข้อมูล...',
      isLoading: true,
      startAmont: '0',
      endAmont: '9999999',
      filterUsername: '',
      startDate: this.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: this.moment().format('YYYY-MM-DD HH:mm:ss'),
      filterType: 0,
      filterSelectType: [
        {
          val: 0,
          name: 'ALL',
          sentname: 'All'
        },
        {
          val: 1,
          name: 'เข้า',
          sentname: 'in'
        },
        {
          val: 2,
          name: 'ออก',
          sentname: 'out'
        },
        {
          val: 3,
          name: 'เพิ่มเงิน',
          sentname: 'add'
        },
        {
          val: 4,
          name: 'ลดเงิน',
          sentname: 'minus'
        }
      ],
      filterStatus: 0,
      filterSelectStatus: [
        {
          val: 0,
          status: 'all',
          name: 'ทั้งหมด',
          sentname: 'ทั้งหมด'
        },
        {
          val: 1,
          status: 'success',
          name: 'ทำรายการสำเร็จ',
          sentname: 'ทำรายการสำเร็จ'
        },
        {
          val: 2,
          status: 'failed',
          name: 'ทำรายการไม่สำเร็จ',
          sentname: 'ทำรายการไม่สำเร็จ'
        }
      ],
      config: {
        enableTime: true
      },
      pagination: {
        total: 0,
        perPage: 100,
        currentPage: 1,
        lastPage: 1
      }
    }
  },
  watch: {
    'pagination.perPage': {
      handler () {
        this.pagination.currentPage = 1
        this.getDataTransaction(this.currentWebsite)
      }
    }
  },
  computed: {
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  async mounted () {
    await this.getDataTransaction(this.currentWebsite)
  },
  methods: {
    clearSearchBox () {
      this.startDate = this.moment()
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
      this.endDate = this.moment().format('YYYY-MM-DD HH:mm:ss')
      this.filterType = 0
      this.filterStatus = 0
      this.startAmont = ''
      this.endAmont = ''
      this.filterUsername = ''
      this.pagination.currentPage = 1
      this.getDataTransaction(this.currentWebsite)
    },
    async getDataTransaction (from_website) {
      const { value } = from_website
      this.dataTransaction = []
      this.noDataText = 'โปรดรอสักครู่ ระบบกำลังดึงข้อมูล...'
      this.isLoading = true

      try {
        const response = await axios.post('/trxtransfer/transferlist', {
          from_website: value,
          status_search: this.filterSelectStatus[this.filterStatus].status,
          transaction_type_search:
              this.filterSelectType[this.filterType].sentname,
          start_date: this.startDate,
          end_date: this.endDate,
          from_txn_amount_search: this.startAmont,
          to_txn_amount_search: this.endAmont,
          username: this.filterUsername,
          page: this.pagination.currentPage,
          per_page: this.pagination.perPage
        })

        if (response.data.data.length <= 0) {
          this.noDataText = 'ไม่พบข้อมูล'
        } else {
          this.dataTransaction = response.data.data
          this.summary = response.data.summary
          this.pagination = response.data.pagination
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.noDataText = 'เกิดข้อผิดพลาดในการดึงข้อมูล'
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (page) {
      this.pagination.currentPage = page
      this.getDataTransaction(this.currentWebsite)
    },
    check_status (status) {
      if (status === 'success') {
        return 'ทำรายการสำเร็จ'
      } else if (status === 'failed') {
        return 'เกิดข้อผิดพลาด'
      } else {
        return 'เกิดข้อผิดพลาด'
      }
    },
    translateDirection (value) {
      switch (value) {
      case 'add':
        return 'เพิ่มเครดิต'
      case 'minus':
        return 'ลดเครดิต'
      case 'in':
        return 'โยกเงินเข้า'
      case 'out':
        return 'โยกเงินออก'
      default:
        return value
      }
    },
    textDirectionClass (value) {
      switch (value) {
      case 'add':
        return 'text-success'
      case 'minus':
        return 'text-danger'
      case 'in':
        return 'text-warning'
      case 'out':
        return 'text-warning'
      default:
        return ''
      }
    },
    currency (amount) {
      amount = (amount * 1.0).toFixed(2)
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        amount = String(amount)
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
    }
  }
}
</script>
  
  <style scoped>
  .b {
    border-radius: 5px;
    padding: 5px;
    /* Add padding here */
    color: white;
    background-color: #792cffde;
  }
  
  .b-success {
    background-color: #03c837de;
  }
  
  .b-failed {
    background-color: #ff0000de;
  }
  
  .b-create {
    background-color: #ffb300de;
  }
  </style>
  